$(document).ready(function () {
    $("body").on("click", ".nav-item", function (e) {
        $(".nav-item").toggleClass("open");
        $(".sidebar").toggleClass("open").parent().toggleClass("expanded");
    });

    $("body").on("click", ".menu-mobile .overlay, .btn-close", function (e) {
        $(".nav-item").toggleClass("open");
        $(".sidebar").toggleClass("open").parent().toggleClass("expanded");
    });

    $("body").on("click", ".menu-item", function (e) {
        if (e.target.tagName != "LI") return;
        $(e.currentTarget).toggleClass("open");
    });

    $("body").on("click", "li.menu-item-has-children > a", function (event) {
        event.preventDefault();
        $(this).next("ul.sub-menu").slideToggle();
        $(this).parent().toggleClass("active");
    });
});
